import { useAppState } from "src/state";
import { Icons } from "src/components/ui/Icons";
import { ViewSchemaRenderer } from "src/components/ui/ViewSchemaRenderer";
import { AgencyOperationsAdminBookingViewSchema } from "src/components/agency/operations/administrator/bookings/AgencyOperationsAdminBookingViewSchema";

export function AgencyOperationsAdminBookingView() {

    const { currentItem } = useAppState().bookings;

    if (!currentItem) return null;

    return (
        <ViewSchemaRenderer
            schema={AgencyOperationsAdminBookingViewSchema}
            data={currentItem}
            title="Booking Overview"
            icon={Icons.booking}
        />
    );
}
